import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import Listing from "../../components/dashboard/paymentPartials/Listing";
import { useGeneral } from "../../components/contexts/GeneralContext";
import { useEffect } from "react";
import { useState } from "react";
import axios from "../../config/axios";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";
import { useLocation } from "react-router-dom";
import SearchBar from "../../components/common/SearchBar";
import SelectBox from "../../components/common/SelectBox";
import GeneralButton from "../../components/common/GeneralButton";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";
import { motion } from "framer-motion";
const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const PaymentsListingPage = () => {
  const { discountCoupons } = useGeneral();
  useScrollToTop();
  const location = useLocation();
  const getFiltersFromURL = () => {
    const params = new URLSearchParams(location.search);
    return {
      search: params.get("search") || "",
      purpose: params.get("purpose") || "",
      status: params.get("status") || "",
    };
  };
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState({ items: [], pagination: {} });
  const [error, setError] = useState("");
  const [filters, setFilters] = useState(getFiltersFromURL);
  const fetchPayments = async (pageNum = 1, appliedFilters = filters) => {
    try {
      setLoading(true);

      const params = { page: pageNum };

      if (appliedFilters.purpose) params.purpose = appliedFilters.purpose;
      if (appliedFilters.status) params.status = appliedFilters.status;

      const { data } = await axios.get("/dashboard/payments", { params });

      setContent((prev) => ({
        items: pageNum === 1 ? data.items : [...prev.items, ...data.items],
        pagination: data.pagination,
      }));

      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load payments. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Initial load and when filters change
  useEffect(() => {
    fetchPayments(1, filters);
    setPage(1);
  }, [filters]);
  const handleClearSearch = () => {
    setFilters((prev) => ({ ...prev, search: "" }));
  };

  const handlePurposeChange = (val) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, purpose: val }));
  };

  const handleStatusChange = (val) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, status: val }));
  };

  const handleNext = () => {
    if (content?.pagination?.pageCount && page < content.pagination.pageCount) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchPayments(nextPage, filters);
    }
  };

  const sortOptions = [
    { label: "Meal Subscription", value: "meal-subscription" },
    { label: "Product Order", value: "product-order" },
  ];
  return (
    <>
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        {loading && page === 1 && <FullScreenLoading />}
        <Header code={discountCoupons} />
        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper
            component={
              <>
                {content?.pagination?.totalItems > 0 && (
                  <div className="mb-6 flex flex-col items-start md:items-center justify-between gap-2 md:mt-2 mt-0">
                    <div className="flex-1 flex flex-col md:flex-row items-center justify-end gap-2 w-full">
                      <div className="flex flex-col md:flex-row items-center justify-end gap-4 w-full xl:w-[75%]">
                        <SelectBox
                          value={filters.purpose}
                          setValue={handlePurposeChange}
                          options={sortOptions}
                          placeholder="Select Purpose"
                        />
                        <SelectBox
                          value={filters.status}
                          setValue={handleStatusChange}
                          options={[
                            { label: "Paid", value: "1" },
                            { label: "Pending", value: "0" },
                            // { label: "Cancelled", value: "2" },
                          ]}
                          placeholder="Select Status"
                        />
                      </div>
                    </div>

                    {(filters.status || filters.purpose) && (
                      <div className="flex flex-wrap items-center gap-2 mt-2 px-3 py-2 bg-[#D06F36]/10 rounded-lg w-full">
                        <span className="text-secondary">Filter: </span>
                        {filters.status && (
                          <div className="flex items-center gap-1 text-orange me-2 py-1 rounded text-sm text-gray-800">
                            {filters.status === "1" ? "Paid" : "Pending"}
                            <button
                              onClick={() =>
                                setFilters({ ...filters, status: "" })
                              }
                              title="Click to remove status"
                              className="ml-1 text-secondary hover:text-secondary/40 transition-colors"
                            >
                              ×
                            </button>
                          </div>
                        )}
                        {filters.purpose && (
                          <div className="flex items-center gap-1 text-orange me-2 py-1 rounded text-sm text-gray-800">
                            {filters.purpose}
                            <button
                              onClick={() =>
                                setFilters({ ...filters, purpose: "" })
                              }
                              title="Click to remove purpose"
                              className="ml-1 text-secondary hover:text-secondary/40 transition-colors"
                            >
                              ×
                            </button>
                          </div>
                        )}
                        <button
                          onClick={() => {
                            handleClearSearch();
                            setFilters({ purpose: "", status: "" });
                          }}
                          className="ml-auto text-xs text-[#D06F36] font-medium hover:underline transition-all duration-200"
                        >
                          Clear All
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {!loading && error ? (
                  <ApiErrorMessage
                    message1="Failed to load payment"
                    message2="Please check your connection and try again."
                  />
                ) : !loading && !content?.items?.length ? (
                  <NoItemsFound
                    message1="No Payments Found"
                    message2={
                      filters.search || filters.status
                        ? "Try a different query or filter"
                        : "Subscribe to a meal plan or place your first order to see payment details here."
                    }
                  />
                ) : (
                  <motion.div
                    initial={{ opacity: 0, y: -30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1, duration: 0.5, ease: "easeOut" }}
                    className="p-6 lg:px-12 bg-[#DEE2DD]/40 rounded-[15px] shadow-md"
                  >
                    {/* ✅ Now MySubscriptions can trigger API */}
                    <Listing payments={content?.items} />

                    {content.pagination?.pageCount > 1 &&
                      page < content.pagination.pageCount && (
                        <div className="col-span-full flex justify-center w-full mt-2 xl:mt-4">
                          <GeneralButton
                            text={loading ? "Loading..." : "Load More"}
                            title="Click to load more items"
                            onClick={handleNext}
                            disabled={loading}
                            bgColor="#D06F36"
                          />
                        </div>
                      )}

                    {loading && page > 1 && (
                      <div className="col-span-full flex justify-center mt-3">
                        <div className="w-5 h-5 border-4 border-tertiary border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    )}
                  </motion.div>
                )}
              </>
            }
          />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default PaymentsListingPage;
